export default __webpack_public_path__ + "static/media/Reports_black.189c7c81.svg";